import { useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useEffect } from "react";
import { EventTypes } from "redux-store/slices/events/events.interfaces";
import { GameStatus } from "redux-store/slices/game/game.interfaces";

export const useGamePage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const chosenLevel = useSelector(selectors.getChosenLevel);
  const status = useSelector(selectors.getGameStatus);

  useEffect(() => {
    if (!chosenLevel) {
      window.location.href = "#/";
    } else {
      dispatch(actions.setRemainingTime(chosenLevel.maxTime));
    }
  }, [chosenLevel, dispatch]);

  useEffect(() => {
    dispatch(
      actions.dispatchEvent({
        eventType: EventTypes.QUIZ_VIEW,
        extraData: { quizStepName: "Game page" },
      }),
    );
    dispatch(
      actions.dispatchEvent({
        eventType: EventTypes.QUIZ_START,
        extraData: {},
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (status === GameStatus.SUCCESS || status === GameStatus.FAIL) {
      dispatch(
        actions.dispatchEvent({
          eventType: EventTypes.QUIZ_END,
          extraData: {},
        }),
      );
    }
  }, [dispatch, status]);

  return { isMobile };
};
